<template>
  <div class="video-dialog" v-if="message">
    <div class="popup-content">
      <div class="header">
        <span class="title">讨论时间</span>
        <span class="time">{{ message.consultationTime }}</span>
      </div>
      <div class="warper" v-if="message.isInvite">
        <div class="patient">
          <span>受者：</span>
          {{ message.patientName }}
          <span style="margin: 0 0.2rem"> {{ message.patientGender == 1 ? '男' : '女' }}</span>
          {{ message.patientAge }}
        </div>
        <div class="doctor">
          <img
            class="left-icon"
            src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/zuo.png"
            mode=""
          />
          <img
            class="right-icon"
            src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/you.png"
            mode=""
          />
          <div class="photo">
            <img src="https://pharmacyimg.docbook.com.cn/mini_doctor/default-photo.jpg" mode="" />
          </div>
          <div class="name" v-if="message.applyDoctor">
            <span style="font-weight: 500; font-size: 40rpx; color: #323843">{{
              message.applyDoctor.doctorName
            }}</span>
            医生
          </div>
          <div class="desc">
            邀请您
            <span style="color: rgba(0, 114, 245, 1)">视频通话</span>
          </div>
        </div>
        <div class="btn">
          <div class="join" @click="join">进入视频</div>
          <div class="cancel" @click="cancel">拒绝</div>
        </div>
      </div>
      <div class="warper" v-if="isSend">
        <div class="patient">
          <span>受者：</span>
          {{ message.patientName
          }}<span style="margin: 0 0.2rem"> {{ message.patientGender == 1 ? '男' : '女' }}</span
          >{{ message.patientAge }}
        </div>
        <div class="doctor">
          <img
            class="left-icon"
            src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/zuo.png"
            mode=""
          />
          <img
            class="right-icon"
            src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/you.png"
            mode=""
          />
          <div class="photo">
            <img src="https://pharmacyimg.docbook.com.cn/mini_doctor/default-photo.jpg" mode="" />
          </div>
          <div class="name" v-if="message.applyDoctor">
            正在邀请
            <span style="font-weight: 500; font-size: 40rpx; color: #323843">{{
              message.applyDoctor.doctorName
            }}</span>
            医生
          </div>
          <div class="desc" style="margin: 0">
            <span style="color: rgba(0, 114, 245, 1)">视频通话</span>
          </div>
        </div>
        <div class="btn" style="margin-bottom: 0.6rem">
          <div class="join" @click="cancel">取消</div>
        </div>
      </div>
      <div class="warper" v-if="message.isFive">
        <div class="doctor">
          <div class="patient-text">
            {{ message.patientName }}<span>{{ message.patientGender == 1 ? '男' : '女' }}</span
            >{{ message.patientAge }}
          </div>
          <div class="desc"><span style="color: rgba(0, 114, 245, 1)">5分钟</span>后开始</div>
        </div>
        <div class="btn" style="margin-top: 2rem">
          <div class="join" @click="toJoin">发起视频</div>
          <div class="cancel" @click="toCancel">关闭</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NativeMessagePush, NativeMessageData } from '@utils/nativeBridge/nativeMessage'
import javaRequest from '@utils/request/javaRequest'
export default {
  name: 'videoDialog',
  props: {
    data: {}
  },
  data() {
    return {
      message: {},
      isSend: false,
      repeatCallTimer: null
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      javaRequest
        .get(
          `/departmental-consortium/MultiPartyConsultations/${this.data.multiPartyConsultationId}`
        )
        .then(res => {
          this.message = { ...this.data, ...res.data }
        })
    },
    close() {
      this.socketSend('cancel')
      this.$emit('close')
    },
    toCancel() {
      this.$emit('close')
    },
    cancel() {
      // refuse
      this.socketSend('refuse')
      this.$emit('close')
    },
    join() {
      // 进入会议
      console.log(this.message)
      this.socketSend('agree')
      this.$nativeBridge.sendMessage(
        new NativeMessagePush({
          pageName: 'joinMeeting',
          params: {
            zoomMeetingId: this.message.meetingNumber,
            userName: this.message.applyDoctor.doctorName,
            isAutoAudioLink: 1
          }
        })
      )
      this.$emit('close')
    },

    toJoin() {
      javaRequest
        .post('/departmental-consortium/MultiPartyConsultations/createMeeting', {
          multiPartyConsultationId: this.data.multiPartyConsultationId,
          doctorId: this.data.doctorID
        })
        .then(res => {
          const { data } = res
          javaRequest
            .post('/departmental-consortium/MultiPartyConsultations/createMeetingRemind', {
              multiPartyConsultationId: this.data.multiPartyConsultationId
            })
            .then(res => {
              let params = {
                action: 'sendmsg',
                touserid: this.message.applyDoctor.userID,
                userid: localStorage.getItem('userID'),
                toplatform: 'web',
                message: JSON.stringify({
                  action: 'videocall',
                  userid: localStorage.getItem('userID'),
                  username: this.message.applyDoctor.doctorName,
                  callstatus: 'call',
                  platform: 'web',
                  meetingNumber: data.meetingNumber,
                  touserid: this.message.applyDoctor.userID,
                  isInvite: true,
                  multiPartyConsultationId: this.data.multiPartyConsultationId
                })
              }
              this.message.isFive = false
              this.isSend = true
              this.$socket.sendMessage(params, {
                action: params.touserid,
                handler: (socketData, sendMessage, leave) => {
                  this.socketRsponse(socketData, sendMessage, leave, params)
                }
              })
            })
        })
    },
    socketRsponse({ videocallreturn, errcode }, sendMessage, leave, message) {
      console.log(videocallreturn, errcode)
      let count = 1
      if (
        videocallreturn == 'refuse' ||
        videocallreturn == 'stop' ||
        videocallreturn == 'overtime'
      ) {
        this.repeatCallTimer && clearInterval(this.repeatCallTimer)
        this.repeatCallTimer = null
        leave(message.touserid)
        this.$emit('close')
      } else if (errcode == '1013') {
        let _this = this
        if (!this.repeatCallTimer) {
          this.repeatCallTimer = setInterval(() => {
            count++
            if (count <= 13) {
              sendMessage(message)
            } else {
              clearInterval(_this.repeatCallTimer)
              _this.repeatCallTimer = null
              _this.$refs.video.close()
              count = 1
              leave(message.touserid)
            }
          }, 5000)
        }
      } else if (videocallreturn == 'agree') {
        this.repeatCallTimer && clearInterval(this.repeatCallTimer)
        this.repeatCallTimer = null
        leave(message.touserid)
        const { applyDoctor, consultationDoctor } = this.message
        this.$emit('close')
        javaRequest
          .post(
            `/departmental-consortium/MultiPartyConsultations/${this.id}?action=noticeEnterMeeting`
          )
          .then(res => {
            this.$nativeBridge.sendMessage(
              new NativeMessagePush({
                pageName: 'joinMeeting',
                params: {
                  zoomMeetingId: this.message.meetingNumber,
                  isAutoAudioLink: 1,
                  userName:
                    this.applier == 1 ? applyDoctor.doctorName : consultationDoctor.doctorName
                }
              })
            )
          })
      } else if (videocallreturn == 'online') {
        this.repeatCallTimer && clearInterval(this.repeatCallTimer)
        this.repeatCallTimer = null
      }
    },
    // 回复别人的时候touserid 永远是自己
    socketSend(callstatus) {
      let params = {
        action: 'sendmsg',
        touserid: this.message.userid,
        userid: localStorage.getItem('userID'),
        toplatform: 'web',
        message: JSON.stringify({
          action: 'videocall',
          userid: localStorage.getItem('userID'),
          username: this.message.applyDoctor.doctorName,
          callstatus: callstatus,
          videocallreturn: callstatus,
          platform: 'web',
          meetingNumber: this.message.meetingNumber,
          touserid: localStorage.getItem('userID')
        })
      }
      // 消息通知成功之后发送socket
      this.$socket.send(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.video-dialog {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 11110;
  background: rgba(0, 0, 0, 0.6);
}
.popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 12.31rem;
  border-radius: 0.4rem;
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 3rem;
    background: linear-gradient(180deg, #1e68ff 0%, #71b9ff 100%);
    border-radius: 0.4rem 0.4rem 0 0;

    .title {
      font-size: 0.57rem;
      color: #f2f8fe;
    }

    .time {
      font-weight: 600;
      font-size: 0.74rem;
      color: #ffffff;
    }
  }

  .warper {
    position: relative;
    width: 100%;
    background: linear-gradient(180deg, #dbebff 4%, #edf4ff 100%);
    padding: 0.41rem 0.41rem 0 0.41rem;
    border-radius: 0.4rem;
    box-sizing: border-box;
    margin-top: -0.5rem;

    .patient {
      width: 100%;
      height: 1.23rem;
      line-height: 1.23rem;
      text-align: center;
      background: rgba(255, 255, 255, 0.45);
      border: 1px solid rgba(255, 255, 255, 0.25);
      border-radius: 0.4rem;
      font-weight: 600;
      font-size: 0.57rem;
      color: #338ef7;

      > span {
        font-size: 0.57rem;
        color: #338ef7;
      }
    }

    .doctor {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 0.4rem;
      .left-icon {
        position: absolute;
        top: -1.4rem;
        left: -1.3rem;
        width: 2.4rem;
        height: 11.48rem;
      }
      .right-icon {
        position: absolute;
        top: -1.8rem;
        right: -1.2rem;
        width: 2.4rem;
        height: 11.48rem;
      }
      .photo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 5.33rem;
        height: 5.33rem;

        background: url('https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/txbj.png')
          no-repeat center/cover;

        > img {
          width: 3.69rem;
          height: 3.69rem;
          border-radius: 100%;
        }
      }
      .patient-text {
        margin-top: 2rem;
        font-weight: 500;
        font-size: 0.86rem;
        color: #323843;
        > span {
          margin: 0 0.6rem;
          font-size: 0.86rem;
        }
      }
      .desc {
        margin-top: 0.6rem;
      }
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 0.4rem;
      .join {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 8.21rem;
        height: 1.81rem;
        background: #0072f5;
        box-shadow: 0rpx 4rpx 10rpx 0rpx rgba(165, 205, 255, 0.65);
        border-radius: 0.32rem;
        font-size: 0.66rem;
        color: #ffffff;
      }
      .cancel {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 8.21rem;
        height: 1.81rem;

        font-size: 0.66rem;
        color: #0072f5;
      }
    }
  }
  .close-icon {
    position: absolute;
    bottom: -60rpx;
    width: 50rpx;
    height: 50rpx;
  }
}
</style>
